(function () {

  const page_header_slider_v2_list = document.querySelectorAll('.js_page_header_slider_v2')

  for (let i = 0; i < page_header_slider_v2_list.length; i++) {
    const slider = page_header_slider_v2_list[i]
    initPageHeaderSliderV2(slider)
  }

  function initPageHeaderSliderV2 (slider) {
    const sliderWrapEl = slider.closest('.page-header-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let sliderOptions = {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: swiperPagination,
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrev,
      },
      on: {
        transitionStart: function () {
          var videos = slider.querySelectorAll('.js_page_header_slider_video')

          Array.prototype.forEach.call(videos, function (video) {
            video.pause()
          })
        },

        transitionEnd: function () {
          var activeIndex = this.activeIndex
          var activeSlide = slider.querySelectorAll('.js_page_header_slider_v2 .swiper-slide')[activeIndex]
          var activeSlideVideo = activeSlide.getElementsByTagName('video')[0]
          if (activeSlideVideo) {
            activeSlideVideo.play()
          }
        },
      }
    }

    // Override from theme
    // if (window.pageHeaderSliderV2Override) {
    //   sliderOptions = window.pageHeaderSliderV2Override(slider)
    // }

    new Swiper(slider, sliderOptions)
  }

})()


